import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './Pages/Login';
import GlobalStyles from './styles/global';
import '@spaceshipapp/cambridge/dist/cambridge.css';
import CouponForm from './Pages/CouponForm';
import CouponDetails from './Pages/CouponDetails';
import { useState } from 'react';
import { CouponContext, CouponDetail } from './contexts/CouponContext';
import CouponConfirm from './Pages/CouponConfirm';

const App = (): React.ReactElement => {
  const [couponCode, setCouponCode] = useState<string[] | undefined>();
  const [couponDetails, setCouponDetails] = useState<CouponDetail[] | undefined>();

  return (
    <Router>
      <GlobalStyles />
      <CouponContext.Provider
        value={{ couponCode, setCouponCode, couponDetails, setCouponDetails }}
      >
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/form" element={<CouponForm />} />
          <Route path="/detail" element={<CouponDetails />} />
          <Route path="/confirm" element={<CouponConfirm />} />
        </Routes>
      </CouponContext.Provider>
    </Router>
  );
};

export default App;
